<div *ngIf="myAuthService?.getSession()?.calendar == 1" class="h-full">
    <mat-card class="mat-elevation-z0 h-full flex flex-col px-5 pb-3">
        <mat-card-title class="flex justify-content-between items-center mt-1">
            <div class="flex items-center">
                <button mat-stroked-button color="primary" class="mr-3 font-bold" *ngIf="showBackButton()" (click)="goBack()">
                    <i class="fa fa-arrow-left"></i> {{ 'general.back' | translate }}
                </button>
                <div class="text-xl font-bold">{{ title }}</div>
            </div>
        </mat-card-title>
        <mat-card-content class="flex-grow overflow-hidden">
            <tx-scheduler [persoId]="persoId" [defaultDate]="defaultDate" class="h-full flex-grow block"></tx-scheduler>
        </mat-card-content>
    </mat-card>
</div>
